import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateBlockingRuleMutationVariables = Types.Exact<{
  input: Types.CreateBlockingRuleInput;
}>;


export type CreateBlockingRuleMutation = { __typename?: 'Mutation', createBlockingRule: { __typename?: 'BlockingRulePayload', blockingRule?: { __typename?: 'BlockingRuleStateData', tenantId: string, blockingRuleId: string, name: string, description: string, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.BlockingRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateBlockingRuleMutationVariables = Types.Exact<{
  input: Types.UpdateBlockingRuleInput;
}>;


export type UpdateBlockingRuleMutation = { __typename?: 'Mutation', updateBlockingRule: { __typename?: 'BlockingRulePayload', blockingRule?: { __typename?: 'BlockingRuleStateData', tenantId: string, blockingRuleId: string, name: string, description: string, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.BlockingRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteBlockingRuleMutationVariables = Types.Exact<{
  input: Types.DeleteBlockingRuleInput;
}>;


export type DeleteBlockingRuleMutation = { __typename?: 'Mutation', deleteBlockingRule: { __typename?: 'BlockingRulePayload', blockingRule?: { __typename?: 'BlockingRuleStateData', tenantId: string, blockingRuleId: string, name: string, description: string, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.BlockingRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreatePromotionRuleMutationVariables = Types.Exact<{
  input: Types.CreatePromotionRuleInput;
}>;


export type CreatePromotionRuleMutation = { __typename?: 'Mutation', createPromotionRule: { __typename?: 'PromotionRulePayload', promotionRule?: { __typename?: 'PromotionRuleStateData', tenantId: string, promotionRuleId: string, name: string, description: string, startDate: Types.TDateISO, endDate: Types.TDateISO, quantityFloor: number, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.PromotionRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdatePromotionRuleMutationVariables = Types.Exact<{
  input: Types.UpdatePromotionRuleInput;
}>;


export type UpdatePromotionRuleMutation = { __typename?: 'Mutation', updatePromotionRule: { __typename?: 'PromotionRulePayload', promotionRule?: { __typename?: 'PromotionRuleStateData', tenantId: string, promotionRuleId: string, name: string, description: string, startDate: Types.TDateISO, endDate: Types.TDateISO, quantityFloor: number, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.PromotionRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeletePromotionRuleMutationVariables = Types.Exact<{
  input: Types.DeletePromotionRuleInput;
}>;


export type DeletePromotionRuleMutation = { __typename?: 'Mutation', deletePromotionRule: { __typename?: 'PromotionRulePayload', promotionRule?: { __typename?: 'PromotionRuleStateData', tenantId: string, promotionRuleId: string, name: string, description: string, startDate: Types.TDateISO, endDate: Types.TDateISO, quantityFloor: number, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.PromotionRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddBlockingRuleLinkedItemsMutationVariables = Types.Exact<{
  input: Types.AddBlockingRuleLinkedItemsInput;
}>;


export type AddBlockingRuleLinkedItemsMutation = { __typename?: 'Mutation', addBlockingRuleLinkedItems: { __typename?: 'BlockingRulePayload', blockingRule?: { __typename?: 'BlockingRuleStateData', tenantId: string, blockingRuleId: string, name: string, description: string, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.BlockingRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveBlockingRuleLinkedItemsMutationVariables = Types.Exact<{
  input: Types.RemoveBlockingRuleLinkedItemsInput;
}>;


export type RemoveBlockingRuleLinkedItemsMutation = { __typename?: 'Mutation', removeBlockingRuleLinkedItems: { __typename?: 'BlockingRulePayload', blockingRule?: { __typename?: 'BlockingRuleStateData', tenantId: string, blockingRuleId: string, name: string, description: string, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.BlockingRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddBlockingRuleLinkedLocationsMutationVariables = Types.Exact<{
  input: Types.AddBlockingRuleLinkedLocationsInput;
}>;


export type AddBlockingRuleLinkedLocationsMutation = { __typename?: 'Mutation', addBlockingRuleLinkedLocations: { __typename?: 'BlockingRulePayload', blockingRule?: { __typename?: 'BlockingRuleStateData', tenantId: string, blockingRuleId: string, name: string, description: string, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.BlockingRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveBlockingRuleLinkedLocationsMutationVariables = Types.Exact<{
  input: Types.RemoveBlockingRuleLinkedLocationsInput;
}>;


export type RemoveBlockingRuleLinkedLocationsMutation = { __typename?: 'Mutation', removeBlockingRuleLinkedLocations: { __typename?: 'BlockingRulePayload', blockingRule?: { __typename?: 'BlockingRuleStateData', tenantId: string, blockingRuleId: string, name: string, description: string, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.BlockingRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddPromotionRuleLinkedItemsMutationVariables = Types.Exact<{
  input: Types.AddPromotionRuleLinkedItemsInput;
}>;


export type AddPromotionRuleLinkedItemsMutation = { __typename?: 'Mutation', addPromotionRuleLinkedItems: { __typename?: 'PromotionRulePayload', promotionRule?: { __typename?: 'PromotionRuleStateData', tenantId: string, promotionRuleId: string, name: string, description: string, startDate: Types.TDateISO, endDate: Types.TDateISO, quantityFloor: number, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.PromotionRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemovePromotionRuleLinkedItemsMutationVariables = Types.Exact<{
  input: Types.RemovePromotionRuleLinkedItemsInput;
}>;


export type RemovePromotionRuleLinkedItemsMutation = { __typename?: 'Mutation', removePromotionRuleLinkedItems: { __typename?: 'PromotionRulePayload', promotionRule?: { __typename?: 'PromotionRuleStateData', tenantId: string, promotionRuleId: string, name: string, description: string, startDate: Types.TDateISO, endDate: Types.TDateISO, quantityFloor: number, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.PromotionRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddPromotionRuleLinkedLocationsMutationVariables = Types.Exact<{
  input: Types.AddPromotionRuleLinkedLocationsInput;
}>;


export type AddPromotionRuleLinkedLocationsMutation = { __typename?: 'Mutation', addPromotionRuleLinkedLocations: { __typename?: 'PromotionRulePayload', promotionRule?: { __typename?: 'PromotionRuleStateData', tenantId: string, promotionRuleId: string, name: string, description: string, startDate: Types.TDateISO, endDate: Types.TDateISO, quantityFloor: number, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.PromotionRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemovePromotionRuleLinkedLocationsMutationVariables = Types.Exact<{
  input: Types.RemovePromotionRuleLinkedLocationsInput;
}>;


export type RemovePromotionRuleLinkedLocationsMutation = { __typename?: 'Mutation', removePromotionRuleLinkedLocations: { __typename?: 'PromotionRulePayload', promotionRule?: { __typename?: 'PromotionRuleStateData', tenantId: string, promotionRuleId: string, name: string, description: string, startDate: Types.TDateISO, endDate: Types.TDateISO, quantityFloor: number, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.PromotionRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateBlockingRuleDocument = new TypedDocumentString(`
    mutation CreateBlockingRule($input: CreateBlockingRuleInput!) {
  createBlockingRule(input: $input) {
    blockingRule {
      ...BlockingRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment BlockingRuleFields on BlockingRuleStateData {
  tenantId
  blockingRuleId
  name
  description
  startDate
  endDate
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const UpdateBlockingRuleDocument = new TypedDocumentString(`
    mutation UpdateBlockingRule($input: UpdateBlockingRuleInput!) {
  updateBlockingRule(input: $input) {
    blockingRule {
      ...BlockingRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment BlockingRuleFields on BlockingRuleStateData {
  tenantId
  blockingRuleId
  name
  description
  startDate
  endDate
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const DeleteBlockingRuleDocument = new TypedDocumentString(`
    mutation DeleteBlockingRule($input: DeleteBlockingRuleInput!) {
  deleteBlockingRule(input: $input) {
    blockingRule {
      ...BlockingRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment BlockingRuleFields on BlockingRuleStateData {
  tenantId
  blockingRuleId
  name
  description
  startDate
  endDate
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const CreatePromotionRuleDocument = new TypedDocumentString(`
    mutation CreatePromotionRule($input: CreatePromotionRuleInput!) {
  createPromotionRule(input: $input) {
    promotionRule {
      ...PromotionRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PromotionRuleFields on PromotionRuleStateData {
  tenantId
  promotionRuleId
  name
  description
  startDate
  endDate
  quantityFloor
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const UpdatePromotionRuleDocument = new TypedDocumentString(`
    mutation UpdatePromotionRule($input: UpdatePromotionRuleInput!) {
  updatePromotionRule(input: $input) {
    promotionRule {
      ...PromotionRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PromotionRuleFields on PromotionRuleStateData {
  tenantId
  promotionRuleId
  name
  description
  startDate
  endDate
  quantityFloor
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const DeletePromotionRuleDocument = new TypedDocumentString(`
    mutation DeletePromotionRule($input: DeletePromotionRuleInput!) {
  deletePromotionRule(input: $input) {
    promotionRule {
      ...PromotionRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PromotionRuleFields on PromotionRuleStateData {
  tenantId
  promotionRuleId
  name
  description
  startDate
  endDate
  quantityFloor
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const AddBlockingRuleLinkedItemsDocument = new TypedDocumentString(`
    mutation AddBlockingRuleLinkedItems($input: AddBlockingRuleLinkedItemsInput!) {
  addBlockingRuleLinkedItems(input: $input) {
    blockingRule {
      ...BlockingRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment BlockingRuleFields on BlockingRuleStateData {
  tenantId
  blockingRuleId
  name
  description
  startDate
  endDate
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const RemoveBlockingRuleLinkedItemsDocument = new TypedDocumentString(`
    mutation RemoveBlockingRuleLinkedItems($input: RemoveBlockingRuleLinkedItemsInput!) {
  removeBlockingRuleLinkedItems(input: $input) {
    blockingRule {
      ...BlockingRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment BlockingRuleFields on BlockingRuleStateData {
  tenantId
  blockingRuleId
  name
  description
  startDate
  endDate
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const AddBlockingRuleLinkedLocationsDocument = new TypedDocumentString(`
    mutation AddBlockingRuleLinkedLocations($input: AddBlockingRuleLinkedLocationsInput!) {
  addBlockingRuleLinkedLocations(input: $input) {
    blockingRule {
      ...BlockingRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment BlockingRuleFields on BlockingRuleStateData {
  tenantId
  blockingRuleId
  name
  description
  startDate
  endDate
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const RemoveBlockingRuleLinkedLocationsDocument = new TypedDocumentString(`
    mutation RemoveBlockingRuleLinkedLocations($input: RemoveBlockingRuleLinkedLocationsInput!) {
  removeBlockingRuleLinkedLocations(input: $input) {
    blockingRule {
      ...BlockingRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment BlockingRuleFields on BlockingRuleStateData {
  tenantId
  blockingRuleId
  name
  description
  startDate
  endDate
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const AddPromotionRuleLinkedItemsDocument = new TypedDocumentString(`
    mutation AddPromotionRuleLinkedItems($input: AddPromotionRuleLinkedItemsInput!) {
  addPromotionRuleLinkedItems(input: $input) {
    promotionRule {
      ...PromotionRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PromotionRuleFields on PromotionRuleStateData {
  tenantId
  promotionRuleId
  name
  description
  startDate
  endDate
  quantityFloor
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const RemovePromotionRuleLinkedItemsDocument = new TypedDocumentString(`
    mutation RemovePromotionRuleLinkedItems($input: RemovePromotionRuleLinkedItemsInput!) {
  removePromotionRuleLinkedItems(input: $input) {
    promotionRule {
      ...PromotionRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PromotionRuleFields on PromotionRuleStateData {
  tenantId
  promotionRuleId
  name
  description
  startDate
  endDate
  quantityFloor
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const AddPromotionRuleLinkedLocationsDocument = new TypedDocumentString(`
    mutation AddPromotionRuleLinkedLocations($input: AddPromotionRuleLinkedLocationsInput!) {
  addPromotionRuleLinkedLocations(input: $input) {
    promotionRule {
      ...PromotionRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PromotionRuleFields on PromotionRuleStateData {
  tenantId
  promotionRuleId
  name
  description
  startDate
  endDate
  quantityFloor
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const RemovePromotionRuleLinkedLocationsDocument = new TypedDocumentString(`
    mutation RemovePromotionRuleLinkedLocations($input: RemovePromotionRuleLinkedLocationsInput!) {
  removePromotionRuleLinkedLocations(input: $input) {
    promotionRule {
      ...PromotionRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PromotionRuleFields on PromotionRuleStateData {
  tenantId
  promotionRuleId
  name
  description
  startDate
  endDate
  quantityFloor
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateBlockingRule: build.mutation<CreateBlockingRuleMutation, CreateBlockingRuleMutationVariables>({
      query: (variables) => ({ document: CreateBlockingRuleDocument, variables })
    }),
    UpdateBlockingRule: build.mutation<UpdateBlockingRuleMutation, UpdateBlockingRuleMutationVariables>({
      query: (variables) => ({ document: UpdateBlockingRuleDocument, variables })
    }),
    DeleteBlockingRule: build.mutation<DeleteBlockingRuleMutation, DeleteBlockingRuleMutationVariables>({
      query: (variables) => ({ document: DeleteBlockingRuleDocument, variables })
    }),
    CreatePromotionRule: build.mutation<CreatePromotionRuleMutation, CreatePromotionRuleMutationVariables>({
      query: (variables) => ({ document: CreatePromotionRuleDocument, variables })
    }),
    UpdatePromotionRule: build.mutation<UpdatePromotionRuleMutation, UpdatePromotionRuleMutationVariables>({
      query: (variables) => ({ document: UpdatePromotionRuleDocument, variables })
    }),
    DeletePromotionRule: build.mutation<DeletePromotionRuleMutation, DeletePromotionRuleMutationVariables>({
      query: (variables) => ({ document: DeletePromotionRuleDocument, variables })
    }),
    AddBlockingRuleLinkedItems: build.mutation<AddBlockingRuleLinkedItemsMutation, AddBlockingRuleLinkedItemsMutationVariables>({
      query: (variables) => ({ document: AddBlockingRuleLinkedItemsDocument, variables })
    }),
    RemoveBlockingRuleLinkedItems: build.mutation<RemoveBlockingRuleLinkedItemsMutation, RemoveBlockingRuleLinkedItemsMutationVariables>({
      query: (variables) => ({ document: RemoveBlockingRuleLinkedItemsDocument, variables })
    }),
    AddBlockingRuleLinkedLocations: build.mutation<AddBlockingRuleLinkedLocationsMutation, AddBlockingRuleLinkedLocationsMutationVariables>({
      query: (variables) => ({ document: AddBlockingRuleLinkedLocationsDocument, variables })
    }),
    RemoveBlockingRuleLinkedLocations: build.mutation<RemoveBlockingRuleLinkedLocationsMutation, RemoveBlockingRuleLinkedLocationsMutationVariables>({
      query: (variables) => ({ document: RemoveBlockingRuleLinkedLocationsDocument, variables })
    }),
    AddPromotionRuleLinkedItems: build.mutation<AddPromotionRuleLinkedItemsMutation, AddPromotionRuleLinkedItemsMutationVariables>({
      query: (variables) => ({ document: AddPromotionRuleLinkedItemsDocument, variables })
    }),
    RemovePromotionRuleLinkedItems: build.mutation<RemovePromotionRuleLinkedItemsMutation, RemovePromotionRuleLinkedItemsMutationVariables>({
      query: (variables) => ({ document: RemovePromotionRuleLinkedItemsDocument, variables })
    }),
    AddPromotionRuleLinkedLocations: build.mutation<AddPromotionRuleLinkedLocationsMutation, AddPromotionRuleLinkedLocationsMutationVariables>({
      query: (variables) => ({ document: AddPromotionRuleLinkedLocationsDocument, variables })
    }),
    RemovePromotionRuleLinkedLocations: build.mutation<RemovePromotionRuleLinkedLocationsMutation, RemovePromotionRuleLinkedLocationsMutationVariables>({
      query: (variables) => ({ document: RemovePromotionRuleLinkedLocationsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateBlockingRuleMutation, useUpdateBlockingRuleMutation, useDeleteBlockingRuleMutation, useCreatePromotionRuleMutation, useUpdatePromotionRuleMutation, useDeletePromotionRuleMutation, useAddBlockingRuleLinkedItemsMutation, useRemoveBlockingRuleLinkedItemsMutation, useAddBlockingRuleLinkedLocationsMutation, useRemoveBlockingRuleLinkedLocationsMutation, useAddPromotionRuleLinkedItemsMutation, useRemovePromotionRuleLinkedItemsMutation, useAddPromotionRuleLinkedLocationsMutation, useRemovePromotionRuleLinkedLocationsMutation } = injectedRtkApi;
